export const ApiResponseFunc = {
   methods: {
      getErrorStatusCode(error){
         let status_code = null;

         if (
            typeof error.response != 'undefined'
            && typeof error.response.data != 'undefined'
            && typeof error.response.data.data != 'undefined'
            && typeof error.response.data.data.status_code != 'undefined'
         ) status_code = error.response.data.data.status_code;

         return status_code;
      },

      errorMsg(error){
         var msg

         if(
            typeof error.response != 'undefined'
            && typeof error.response.data != 'undefined'
            && typeof error.response.data.data != 'undefined'
            && typeof error.response.data.data.msg != 'undefined'
         ) {
            msg = error.response.data.data.msg;
         } else {
            switch (error.status){
               case 403 : msg = `권한이 없습니다.`; break;
               case 409 : msg = error.response.data.data.msg; break;
               default : msg = `오류가 발생하였습니다. 문의해주세요.`; break;
               // default : msg = `[${error.status}] ${error.response.statusText}`; break;
            }

            if(typeof error.status != 'undefined' && error.status != 409) msg = `[${error.status}] `+ msg;
         }
         
         return msg;
      },
      
      oasRedirect(path){
         this.$store.commit('setBtnLoading',true);
         let url = this.$store.state.host.plus 
         if(path) url += path;
         return location.href = url;
      },

      vtgRedirect(path){
         this.$store.commit('setBtnLoading',true);
         let url = this.$store.state.host.vtg 
         if(path) url += path;
         return location.href = url;
      },

      checkMobile(){
         var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
         var type = null;
         var link = null;
         if ( varUA.indexOf('android') > -1) { 
            //안드로이드
            type = 'andoroid'
            link = 'https://play.google.com/store/apps/details?id=kr.co.bmwkorea.plus';
         } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
            //IOS
            type = 'ios'
            link = 'https://apps.apple.com/kr/app/bmw-plus/id1281874994';
         } else {
            //아이폰, 안드로이드 외
            type = 'etc'
            link = '/subscribe';
            // link = 'https://play.google.com/store/apps/details?id=kr.co.bmwkorea.plus';
         } 
         if(type == 'etc') {
            if(this.$route.path == '/subscribe') return;
            else return this.$router.push('/subscribe');
         } if(link) return location.href = link;
      }

   }
};